import Container, { Service } from 'typedi';
import { WebPushService } from './web.push.service';
import { LoggerProvider, ILogger } from '../logger';
import { ServiceWorkerService } from './service.worker.service';
import { IWebPushController } from './models/IWebPushController';

@Service()
export class WebPushController implements IWebPushController {
    private readonly _logger: ILogger;
    private readonly _webPushService: WebPushService;
    private readonly _serviceWorkerService: ServiceWorkerService;

    constructor() {
        this._logger = Container.get(LoggerProvider).getLogger('WebPushController');
        this._webPushService = Container.get(WebPushService);
        this._serviceWorkerService = Container.get(ServiceWorkerService);
    }

    public registerUrbanAirshipService(): void {
        this._serviceWorkerService.registerServiceWorker();
        const serviceWorkerUrl = this._serviceWorkerService.getServiceWorkerUrl();
        this._webPushService.setServiceWorkerUrl(serviceWorkerUrl);
        this._webPushService.setEventListeners();
        this._webPushService.setMessageBrokerSubscribers();
    }
}
